import { useState } from "react";
import { Image } from "react-bootstrap";
import check from "../../assets/images/check.svg";
import "../../assets/scss/components/templates/customCheckbox.scss";

const CustomCheckBox = ({ text }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="checkbox">
      <div className="custom-checkbox-container">
        <input
          type="checkbox"
          id="customCheckbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="hidden-checkbox"
        />
        <label
          htmlFor="customCheckbox"
          className={`custom-checkbox ${isChecked ? "checked" : ""}`}
        >
          {isChecked && (
            <span className="checkmark">
              <Image src={check} />
            </span>
          )}
        </label>
      </div>
      <p className="paragraph-main-regular text-start remember-text">{text}</p>
    </div>
  );
};

export default CustomCheckBox;
